export default __webpack_public_path__ + "static/media/points.81c4e139.svg";